var _defs, _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _polygon, _rect, _path13, _path14, _path15, _polygon2, _rect2, _path16, _path17, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoEdcontinuaBlanco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 367.4 91.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M115,12h12.9v1.3h-11.4v9.6h9.4v1.3h-9.4v9.8h12.1v1.3h-13.5V12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M140.2,12h7.4c7,0,11.7,4.3,11.7,11.8s-4.7,11.8-11.7,11.8h-7.4V12ZM147.4,34.2c6.2,0,10.4-3.7,10.4-10.4s-4.2-10.4-10.4-10.4h-5.7v20.8h5.7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M170.8,12h1.4v15.4c0,4.4,2.9,7.2,7.3,7.2s7.4-2.7,7.4-7.2v-15.3h1.4v15.5c0,5.2-3.6,8.5-8.8,8.5s-8.8-3.3-8.8-8.5v-15.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M211.4,11.6c5.6,0,8.4,3,8.4,3l-.9,1.1s-2.8-2.7-7.5-2.7-10.2,4.5-10.2,10.6,4.4,11,10.3,11,8-3.2,8-3.2l.9,1s-3.2,3.6-8.9,3.6-11.8-5.5-11.8-12.3,5-12,11.7-12Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M243.5,27.4h-10l-3,8.1h-1.5l8.8-23.5h1.5l8.8,23.5h-1.5l-3.1-8.1ZM238.5,13.7s-.5,1.8-.9,2.8l-3.6,9.5h9l-3.6-9.5c-.4-1-.9-2.8-.9-2.8h0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M268.4,11.6c5.6,0,8.4,3,8.4,3l-.9,1.1s-2.8-2.7-7.5-2.7-10.2,4.5-10.2,10.6,4.4,11,10.3,11,8-3.2,8-3.2l.9,1s-3.2,3.6-8.9,3.6-11.8-5.5-11.8-12.3,5-12,11.7-12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M289,12h1.4v23.5h-1.4V12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M314,11.6c6.6,0,11.9,5.2,11.9,12s-5.3,12.3-11.9,12.3-11.9-5.4-11.9-12.3,5.3-12,11.9-12ZM314,34.6c5.7,0,10.4-4.8,10.4-11s-4.6-10.6-10.4-10.6-10.4,4.6-10.4,10.6,4.6,11,10.4,11ZM315.5,6.6h1.9l-2.7,3.7h-1.5l2.3-3.7Z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M337.5,12h1.3l13.4,18.4c.8,1.1,1.9,3,1.9,3h0s-.2-1.8-.2-3V12h1.4v23.5h-1.3l-13.4-18.4c-.8-1.1-1.9-3-1.9-3h0s.2,1.8.2,3v18.4h-1.4V12Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.1,47.5v28.4c.1,1.2,1.1,2.2,2.4,2.3h11.5l-13.4-30.5c-.1-.2-.3-.6-.3-.9,0,.2-.1.4-.1.7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71,47.5v28.4c-.1,1.2-1.1,2.2-2.4,2.3h-11.5l13.4-30.5c.1-.2.3-.6.3-.9,0,.2.1.4.1.7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.3,16.8c1.1-2.6-.3-4.4-3.1-4.4h-19.4c0,.4,0,.8,0,1.3,0,4.9-4,8.9-8.9,8.9s-8.9-4-8.9-8.9,0-.9,0-1.3H10.8c-2.8,0-4.2,1.8-3.1,4.4l31.3,71.1,31.3-71.1Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.9,17.5c-.4,0-.5,0-.8,0h-.2s0-1.5,0-1.5h.5c0,0,0,.1,0,.2.1.5.4.8.8.8.5.1,1-.1,1.1-.6,0-.4,0-.7-.6-.9h-.3c0-.1-.2-.2-.2-.2,0,0-.2,0-.2-.1-.5-.3-.8-.5-.9-.9,0-.1,0-.2,0-.3-.2-1.1.7-1.9,2.2-1.7,0,0,.1,0,.2,0h.2c0,0,0,0,0,0,0,0,.1,0,.2,0,.2,0,.3,0,.4,0v1.5h-.5c0,0,0-.2,0-.2-.1-.4-.3-.7-.6-.8,0,0-.1,0-.2,0-.4,0-.8.2-.9.5,0,.3,0,.5.3.7,0,0,.2.1.5.3h.2c0,0,.3.2.3.2.8.4,1.1.9,1.1,1.6,0,1.1-1,1.8-2.7,1.4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.2,12.9s0,0,0,0c-.4,0-.5.2-.6.8,0,0,0,0,0,.1v2.4s0,0,0,0c0,.6.1.7.5.8,0,0,0,0,0,0v.4h-2.5v-.4h0c.5,0,.6-.2.6-.7h0v-1.2h-1.6v1.1h0c0,.7.1.8.6.9h0v.4h-2.5v-.4s0,0,0,0c.4,0,.5-.2.5-.8,0,0,0,0,0,0v-2.4s0,0,0,0c0-.6-.1-.7-.6-.8,0,0,0,0,0,0v-.5h2.5v.5s0,0-.1,0c-.4,0-.5.2-.5.6v.3s0,.8,0,.8h1.6v-1c0-.4-.1-.6-.5-.6,0,0,0,0-.1,0v-.5h2.5v.5Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.2,12.9h0c-.5,0-.6.2-.7.6v.2s0,0,0,0v2.5h0c0,.2,0,.2,0,.3,0,.3.2.4.6.5h0v.4h-2.7v-.5h0c.5,0,.6-.2.6-.6v-.2s0-.1,0-.1v-2.6c0-.4-.2-.6-.6-.6h0v-.4h2.6v.5Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "36.8 7.7 38.2 7.7 38.2 6.4 39.5 6.4 39.5 7.7 40.9 7.7 40.9 8.9 39.5 8.9 39.5 11.3 38.2 11.3 38.2 8.9 36.8 8.9 36.8 7.7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 93.3,
    y: 8.9,
    width: 1.7,
    height: 72.2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M131.8,76.4c-7.3,0-12.2-6-12.2-13s4.8-12.6,12.1-12.6,9.5,3.6,9.5,3.6l2.3-3.4s-4-4.3-12-4.3-16.7,7.3-16.7,16.8,6.9,17.2,16.8,17.2,12.8-5.2,12.8-5.2l-2.5-3.3s-4,4.3-10.1,4.3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M165.1,46.7c-9.5,0-16.9,7.3-16.9,16.8s7.4,17.2,16.9,17.2,16.8-7.5,16.8-17.2-7.4-16.8-16.8-16.8M165.1,76.4c-6.7,0-12.1-5.6-12.1-13s5.4-12.6,12.1-12.6,12.1,5.4,12.1,12.6-5.4,13-12.1,13"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M210.3,68.6c0,1.8.3,4.7.3,4.7h0s-1.5-3-2.7-4.7l-14.6-21.4h-4.6v32.9h4.6v-21.3c0-1.9-.3-4.8-.3-4.8h0s1.5,3,2.7,4.8l14.7,21.3h4.5v-32.9h-4.6v21.4Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "219.6 51.2 230.9 51.2 230.9 80.1 235.5 80.1 235.5 51.2 246.8 51.2 246.8 47.2 219.6 47.2 219.6 51.2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 251.5,
    y: 47.2,
    width: 4.6,
    height: 32.9
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M346.4,47.2h-4.8l-11.8,32.9h4.7l3.3-9.4h12.4l3.3,9.4h4.8l-11.8-32.9ZM338.9,66.8l3.7-10.4c.6-1.7,1.3-4.7,1.3-4.7h0s.7,3,1.3,4.7l3.6,10.4h-10Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M329.8,49.9c-2.3,0-4.2,1.9-4.2,4.2v3.4s0,10.9,0,10.9c0,7.3-5.3,12.2-12.9,12.2s-12.9-4.9-12.9-12.2v-14.3c0-2.3-1.9-4.2-4.2-4.2s-4.2,1.9-4.2,4.2v3.4s0,22.5,0,22.5h-4.5l-14.7-21.3c-1.2-1.8-2.7-4.8-2.7-4.8h0s.3,2.9.3,4.8v21.3h-4.6v-32.9h4.6l14.6,21.4c1.2,1.8,2.7,4.7,2.7,4.7h0s-.3-2.9-.3-4.7v-11.4s0-3.1,0-3.1c0-4.9,4-8.8,8.8-8.8s8.8,4,8.8,8.8v3.1s0,11.2,0,11.2c0,5,3.3,8,8.3,8s8.4-2.9,8.4-8v-14.3c0-4.9,4-8.8,8.8-8.8h21v-1.9c0-.4.5-.6.8-.4l5.7,4.2c.3.2.3.6,0,.8l-5.7,4.2c-.3.2-.8,0-.8-.4v-1.9h-21Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -237.8,
    y: -250.5,
    width: 841.9,
    height: 595.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEdcontinuaBlanco);
export default __webpack_public_path__ + "static/media/logo-edcontinua-blanco.52515a0089ca65983c8b3f6ad736be84.svg";
export { ForwardRef as ReactComponent };